// import dependencies
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
// import assets and scss
import "./patientLIMSInstructions.scss";
import noDataFound from "../../assets/no-instructions-found.png";
// import project files
import Loader from "../UI Component/Loader/Loader";
// api constants and helper methods
import { c2cGetApiHandler } from "../../Util/c2cApiHandler";
import { GET_INSTRUCTIONS_API } from "./constants/apiConstants";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { USER_TYPE } from "../../Util/constants";
import sessionExpiredError from "../Errors/sessionExpiredError";

const PatientLIMSInstructions = () => {
  const [instructionList, setInstructionList] = useState([]);
  const [loader, setLoader] = useState(true);
  const params = useParams();
  const history = useHistory();
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  // Life cycle methods
  useEffect(() => {
    if (localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN)) {
      getInstructionsApiCall(params?.appointment_id);
    } else {
      window.location.replace(
        `/${window.location.pathname.split("/")[1]}/login`
      );
    }
  }, [params?.appointment_id]);

  // Api Calls
  const getInstructionsApiCall = (appointmentId) => {
    setLoader(true);
    let params = {
      appointment_id: appointmentId,
      user_id: userType === USER_TYPE.STAFF ? staffId : userId,
    };
    c2cGetApiHandler(GET_INSTRUCTIONS_API, params).then(([res, error]) => {
      if (res?.data?.statusCode === 200) {
        setInstructionList(res?.data?.data);
        setLoader(false);
      } else if (res?.data?.statusCode === 403) {
        sessionExpiredError(() => {
          localStorage.clear();
          history.push("/doctor/login");
        });
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  };

  // display UI
  const displayInstructionsUI = () => {
    return (
      <div className="patient-lims-instructions-ui">
        <h2 className="plil-heading">Instructions</h2>
        <div className="patient-lims-instructions-list">
          {instructionList?.map((item, index) => (
            <div className="plil-item">
              <div className="plil-item-index">{index + 1}</div>
              <div className="plil-item-data">
                <p className="plil-id-name">{item?.procedure_name}</p>
                <p className="plil-id-description">{item?.instruction}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const displayNoDataFound = () => {
    return (
      <div className="plic-ndf-container">
        <img src={noDataFound} alt="" />
        <p>No Instructions</p>
      </div>
    );
  };
  return (
    <div className="patient-lims-instructions-container">
      {!loader ? (
        <>
          {instructionList?.length > 0
            ? displayInstructionsUI()
            : displayNoDataFound()}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default PatientLIMSInstructions;
